import { createFileRoute } from "@tanstack/react-router";

import Error404 from "@/components/pages/Error404";

export const Route = createFileRoute("/_auth/error-404")({
  component: Error404,
});
